// ets_tracing: off
import * as Lens from "@effect-ts/monocle/Lens";
import * as Optional from "@effect-ts/monocle/Optional";
import * as Prism from "@effect-ts/monocle/Prism";

const makeMonocleFor = () => ({
  lens: Lens.id(),
  prism: Prism.id(),
  optional: Optional.id()
});

const staticMonocle = /*#__PURE__*/makeMonocleFor();
export const MonocleFor = () => staticMonocle;
//# sourceMappingURL=index.mjs.map